// extracted by mini-css-extract-plugin
export default {"controls":"T7ODgbldW4509FthUzX4zA==","backButton":"xOBRkWZlDprCNs0kclKXUA==","subtitle":"dLN-9QF4qpo8xKROaYrKMw==","selectorItem":"YvRR1gOhVb8ioSQDE2Ngfw=="};